import { Box, Stack, Typography, } from '@mui/material';
import React from 'react';
export const LabeledText = ({ label, value, labelProps, valueProps, valueContainerSx, rootContainerProps, }) => {
    return (React.createElement(Stack, { gap: ".2rem", ...(rootContainerProps || {}) },
        label && (React.createElement(Typography, { fontSize: "0.875rem", fontWeight: 500, color: "secondary.light", ...(labelProps || {}) }, label)),
        React.createElement(Typography, { variant: "body1", sx: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                ...(valueContainerSx || {}),
            } },
            React.createElement(Box, { component: "span", fontWeight: 600, fontSize: "0.875rem", color: "secondary.main", ...(valueProps || {}) }, value))));
};
